import { Directive } from '@angular/core';

/**
 * Generated class for the LongPressDirective directive.
 *
 * See https://angular.io/api/core/Directive for more info on Angular
 * Directives.
 */
@Directive({
  selector: '[long-press]' // Attribute selector
})
export class LongPressDirective {

  constructor() {
  }

}



// WEBPACK FOOTER //
// ./src/directives/long-press/long-press.ts